module.exports = __webpack_public_path__ + "img/struc-rect-beam.0da2d8ab.jpg";